






import Vue from 'vue';
import CustomerLogin from '@/components/CustomerLogin.vue';

export default Vue.extend({
	name: 'TheLoginPage',

	components: {
		CustomerLogin,
	},

	props: {
		buttonText: {
			type: String,
			default: 'Login',
		},
		classes: [Object, String, Array],
		forgotPassword: Boolean,
		forgotText: {
			type: String,
			default: 'Forgot Password',
		},
		activateText: {
			type: String,
			default: 'Activate Account',
		},
		id: String,
		location: String,
		loginGreeting: { type: String, default: '[FirstName] [LastName]' },
		noLoginGreeting: { type: String, default: 'Welcome! [Login /] or [Register /]' },
		redirect: { type: String, default: 'profile' },
		registerText: { type: String, default: 'Sign Up' },
		title: String,
		type: { type: String, default: 'login-only' },
	},

	computed: {
		paths(): App.Paths {
			return this.$store.state.paths;
		},
	},

	methods: {
		onLogin() {
			window.location.replace(this.paths.profile);
		},
	},
});
